import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20luxurious%20live%20streaming%20studio%20with%20beautiful%20female%20host%20performing%20on%20a%20glamorous%20stage%20with%20warm%20golden%20spotlights%20and%20sparkling%20decorative%20elements%2C%20professional%20broadcast%20production%20with%20cinematic%20lighting%2C%20sophisticated%20atmosphere&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="美女直播平台精选 - 高颜值主播实时互动"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-white/90 text-sm font-medium">超过200位主播正在直播中</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          美女直播平台精选
          <br />
          <span className="text-accent-300">高颜值主播实时互动</span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          探索最热门的美女直播平台，汇聚高颜值主播实时在线互动。多元直播内容涵盖才艺表演、游戏陪玩、生活分享，与你喜爱的主播零距离互动。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/categories"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-live-line text-lg"></i>
            立即进入直播频道
          </Link>
          <Link
            to="/articles"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white font-medium text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-article-line"></i>
            查看直播资讯
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8 mt-12">
          <div className="text-center">
            <p className="text-white font-heading font-bold text-2xl md:text-3xl">500+</p>
            <p className="text-white/70 text-sm mt-1">优质主播</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-white font-heading font-bold text-2xl md:text-3xl">50万+</p>
            <p className="text-white/70 text-sm mt-1">日活用户</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-white font-heading font-bold text-2xl md:text-3xl">99.9%</p>
            <p className="text-white/70 text-sm mt-1">流畅播放</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-white font-heading font-bold text-2xl md:text-3xl">24h</p>
            <p className="text-white/70 text-sm mt-1">全天直播</p>
          </div>
        </div>
      </div>
    </section>
  );
}